import { Box, Container } from '@mui/material';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import PageHeader from 'components/common/PageHeader/PageHeader';
import UsersTable from 'components/tables/UsersTable/UsersTable';
import useGlobalStyles from 'styles/globalStyles';


export default function AllUsersPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'All Users'}
            buttons={[
              // <CustomButton key='export' text='Export' color='primary' />
            ]}
          />
        </Box>

        <Box mt={3}>
          <UsersTable />
        </Box>
      </Container>
    </Box>
  )
}

